import { useId, useState } from 'react';
import { createEvent } from '../utilities/createEvent';

export const useAccordionItem = () => {
  const id = useId();
  const bodyId = 'accordion-body' + id;
  const triggerId = 'accordion-trigger' + id;

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const bodyProps = (props) => {
    const rps = {
      id: bodyId,
      role: 'region',
      'aria-labelledby': triggerId,
    };

    const rct = {
      isOpen,
    };

    return {
      ...rps,
      ...rct,
      ...props,
    };
  };

  const triggerProps = (props) => {
    const { onClick, ...rest } = props;

    const onClickHandler = () => {
      createEvent(onClick);
      toggle();
    };

    const rps = {
      id: triggerId,
      'aria-expanded': isOpen,
      'aria-controls': bodyId,
    };

    const kbd = {
      onClick: onClickHandler,
    };

    return {
      ...rps,
      ...kbd,
      ...rest,
    };
  };

  return {
    isOpen,
    bodyProps,
    triggerProps,
  };
};
